module.exports = __webpack_public_path__ + "img/attachment.4b896b6d.svg";